import React, { useEffect, useState } from "react";
import { DFXiaomiMessages } from "./DFXiaomiMessages";
import { DFXiaomiVoiceOverlay } from "./DFXiaomiVoiceOverlay";
import { useChatState } from "../../state/ChatState";

interface IAgent {
	agentId: string;
	homeTitle: string;
	language: string;
}

const getLanguageData = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={16}
			height={16}
			viewBox="0 0 64 64"
		>
			<path
				fill="#797b80"
				d="M32 2C15.432 2 2 15.432 2 32l.001.053l-.001.053C2 48.616 15.357 62 31.835 62l.064-.002L32 62c16.568 0 30-13.432 30-30S48.568 2 32 2m28 30c0 2.394-.302 4.717-.866 6.934c-.261-.18-.951.564-1.121-.422c-.213-1.224-1.593-2.074-2.336-1.489s-2.866 2.286-2.971 3.35c-.107 1.063-1.01 2.339-1.433 1.437c-.426-.904-1.698-3.723-1.646-4.467s-.586.266-1.538-1.223c-.956-1.489-2.601-.214-3.928-.958c-1.327-.745-2.813-1.755-3.557-2.073c-.741-.32 1.327 2.977 1.593 2.552c.267-.425 1.327.319 1.646.319s1.167.744.637 1.436s-5.253 3.566-5.731 2.818c-.48-.748-3.29-6.541-3.769-6.186c-.478.355 2.973 6.398 3.557 6.77c.582.373 2.335.054 3.183-.318c.85-.372-1.751 4.148-2.864 4.68c-1.114.531-2.016 2.18-1.54 2.924c.478.744.531 3.563-.476 3.936c-1.01.371-1.381.956-1.063 1.648c.317.69-.742 1.859-1.22 2.604c-.479.744-2.335 2.286-2.495 2.712c-.158.426-2.44.319-3.344.319c-.901 0-.212-1.117-.319-2.073c-.104-.958-.9-1.862-.9-2.34c0-.479-.267-1.596-.637-2.127c-.371-.533-.479-1.543-.107-2.127c.373-.586.637-2.286-.104-3.031c-.744-.744-1.594-2.021-1.009-3.031c.584-1.01-.637-.903-1.645-1.383c-1.009-.479-3.079.16-4.14.32c-1.062.159-2.122-.266-2.441-.799c-.318-.531-1.008-1.86-1.715-2.18c-.705-.318-.301-1.701.123-2.232c.426-.531-.424-1.542 0-1.969c.426-.425.69-1.966 1.539-2.303c.85-.336.69-.567.716-1.365s.955-.798 1.113-1.223c.16-.426.637-.638 1.595-.638c.955 0 2.572-.559 3.342-.745s2.097-.452 1.99.293c-.106.744-.079 1.594.424 1.594c.505 0 1.195.293 1.991.789c.796.495.822.09.929-.469s1.22-.346 2.372.186s2.723.159 3.225.107c.505-.055.718-1.569.585-2.074c-.134-.505-.929.239-1.433-.08c-.504-.318-1.195.08-1.698-.373c-.505-.451-.585-1.515 0-1.541c.583-.027.876-.213 1.22-.611c.346-.399 1.646-.638 2.15-.24c.503.399 1.248.665 1.697.213c.451-.451-.9-1.328-1.194-1.568c-.292-.239-.053-1.01-.344-1.01c-.293 0-.532.132-.372.505c.159.372-.849 1.036-1.01.665c-.158-.373-.423-1.09-.821-1.09s-.928 1.808-.955 2.1s-.717.771-1.273.771s-.556.639-.265.932c.292.292.079 1.462-.451 1.529c-.531.068-.717-.12-.796-.573c-.079-.451-.61-.398-.637-1.329s-.611-1.382-.982-1.808s-1.327-1.675-1.698-1.116s1.327 1.755 1.777 2.073c.453.319.373 1.01.134 1.17s-.69 1.463-.955 1.568c-.267.106-.52-.396-.52-.396c-.398-.159.556-.638.716-.877c.158-.239-1.671-1.914-2.001-2.393s-1.74.398-2.376.08c-.637-.318-1.593 1.196-1.671 2.073c-.081.878-1.116 1.116-2.071 1.116c-.954 0-1.592-.717-1.272-1.435c.318-.718-.16-1.914.398-1.994c.557-.079 2.147 0 2.466-.877c.318-.877-1.513-1.675-.795-1.834c.715-.16 1.831-1.275 2.627-1.914c.794-.638.874-1.435 1.59-1.491c.718-.055-.158-1.381.479-1.779c.638-.399.796 1.436 1.274 1.436s1.431-.16 2.228.239s1.035-.399 1.354-1.437c.318-1.036 1.114-1.595 2.705-2.392c1.592-.798-1.829.239-2.467-.559c-.637-.798.239-2.553.638-3.792c.398-1.24-1.274 1.239-2.15 2.516c-.877 1.276.239 1.834.158 2.711c-.079.878-1.51 1.914-1.51 1.914c-.637.08-.558-1.196-.876-1.754c-.319-.558-.877-.319-1.753.319s-.955-1.515-1.193-2.393c-.237-.876 1.433-1.994 2.218-2.59c.784-.598 2.079-3.471 3.513-5.703s3.503-1.117 4.06-.239c.559.876 1.989.318 3.344 1.914s-.319 2.312-1.829 1.664c-1.515-.648.317 1.606 1.191 2.244c.876.637 1.354-1.436 1.673-1.914c.318-.479 1.511-.239 2.386-1.516c.877-1.276 2.866-1.036 4.002-.896c1.137.141.854-.699.138-1.386c-.53-.508.554-.063 1.83.56C54.476 12.768 60 21.737 60 32m-39.958-9.528c-.264-.273.267-1.348.505-1.667c.24-.319-.664-.213-.609.24c.053.451-.346 1.143-.903 1.329s-1.192.132-.875-.373s.026-.957-.213-1.436c-.238-.479 1.326-.771 1.646-1.063c.318-.292-.503-.479-.478-.93c.027-.453.213-.851.529-.904c.319-.053.617-.257.903-.239c.877.054.609 2.047.929 2.686c.318.637 1.221 1.409 1.141 1.966c-.08.559-.25.878-.9.718c-.653-.16-1.698.824-2.098.638c-.399-.187.69-.692.423-.965m-5.718-11.181c.797.398 1.432-.324 1.988-.479c.659-.182 1.035 2.154.399 2.074c-.637-.08-1.353 1.276-2.273 1.196s-.513-.717-1.548-1.674c-.222-.206-.313-.392-.321-.555c.221-.213.441-.427.67-.632c.358-.095.783-.081 1.085.07m24.902 40.141c.743-.159.6-1.573 1.274-1.648c1.433-.159.053 3.828-.477 4.945c-.531 1.117-.745 1.063-1.25.372c-.507-.69-.343-1.808 0-2.339c.342-.533-.291-1.17.453-1.33"
			></path>
		</svg>
	);
};

export const DFXiaomi = () => {
	const chatState = useChatState();
	const [agents, setAgents] = useState<IAgent[]>([]);
	const [selectedAgent, setSelectedAgent] = useState<IAgent | null>(null);

	const [isMessagesOpen, setIsMessagesOpen] = useState(false);
	const [selectedLanguage, setSelectedLanguage] = useState(
		agents?.[0]?.language ?? "English",
	);
	const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);

	useEffect(() => {
		const _agents =
			chatState.baseConfig?.AGENT_IDS?.split("|")?.map((config, index) => {
				return {
					agentId: config,
					homeTitle:
						chatState.baseConfig?.HOME_TITLES?.split("|")?.[index] ??
						"No title found",
					language:
						chatState.baseConfig?.SUPPORTED_LANGUAGES?.split("|")?.[index] ??
						"No language found",
				};
			}) ?? [];

		setAgents(_agents);
		if (_agents.length > 0) {
			setSelectedAgent(_agents[0]);
			setSelectedLanguage(_agents[0].language);
		}
	}, []);

	const toggleMessages = () => {
		setIsMessagesOpen(!isMessagesOpen);
	};

	const toggleLanguageDropdown = () => {
		setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
	};

	const selectLanguage = (language: string) => {
		setSelectedLanguage(language);
		setSelectedAgent(
			agents.find((agent) => agent.language === language) ?? null,
		);
		setIsLanguageDropdownOpen(false);
	};

	return (
		<div className="h-[100dvh] w-screen bg-[#d5d5d5] flex overflow-hidden p-2 md:p-4">
			{/* Main container */}
			<div
				className="flex w-full h-full relative 
                      portrait:flex-col portrait:md:flex-row
                      landscape:flex-row
                      gap-2"
			>
				{/* Left/Main panel - Voice/AI Interface */}
				<div
					className={`flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 
                        transition-all duration-300 ease-in-out
                        rounded-3xl
                        relative z-10
                        ${
													isMessagesOpen
														? "portrait:h-1/2 portrait:md:h-full portrait:md:flex-1 landscape:flex-1"
														: "portrait:h-full portrait:md:h-full portrait:md:flex-1 landscape:flex-1 landscape:lg:w-full"
												}`}
					style={{
						background: "#f2f6ff",
						borderRadius: "53px",
					}}
				>
					{/* Collapse button - visible on larger screens */}
					<button
						onClick={toggleMessages}
						className="absolute top-6 right-6 w-10 h-10 bg-white rounded-full  
                      flex items-center justify-center cursor-pointer hover:shadow-xl
                      transition-all duration-200 border border-gray-200
                      hidden md:flex bg-[#dce0e8]"
					>
						<svg
							className={`w-6 h-6 text-[#2774ae] transition-transform duration-200 ${
								!isMessagesOpen ? "rotate-180" : ""
							}`}
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M9 5l7 7-7 7"
							/>
						</svg>
					</button>

					{/* Mobile portrait toggle button - bottom right */}
					<button
						onClick={toggleMessages}
						className="absolute bottom-4 right-4 w-12 h-12 bg-white rounded-full shadow-lg 
                      flex items-center justify-center cursor-pointer hover:shadow-xl
                      transition-all duration-200 border border-gray-200
                      portrait:flex landscape:hidden md:hidden"
					>
						<svg
							className="w-6 h-6 text-gray-600"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
							/>
						</svg>
						{!isMessagesOpen && (
							<div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
						)}
					</button>

					{/* Main content */}
					<div className="flex flex-col items-center justify-center px-4 sm:px-8 max-w-2xl">
						<DFXiaomiVoiceOverlay
							agentId={selectedAgent?.agentId}
							text={selectedAgent?.homeTitle}
						/>
					</div>

					{/* Language selector - positioned at bottom left */}
					<div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6">
						<div className="relative">
							{/* Language dropdown trigger */}
							<button
								onClick={toggleLanguageDropdown}
								className="flex items-center space-x-2 
                          rounded-full px-3 py-2 
                          hover:bg-white/90 transition-all duration-200 cursor-pointer
                          active:scale-95"
							>
								{getLanguageData()}
								<span className="text-sm font-medium text-gray-700">
									{selectedLanguage}
								</span>
								<svg
									className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
										isLanguageDropdownOpen ? "rotate-180" : ""
									}`}
									fill="none"
									stroke="currentColor"
									viewBox="0 0 24 24"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M19 9l-7 7-7-7"
									/>
								</svg>
							</button>

							{/* Language dropdown menu */}
							{isLanguageDropdownOpen && (
								<div
									className="absolute bottom-full left-0 mb-2 w-40 bg-white rounded-2xl shadow-lg border border-gray-200 
                                overflow-hidden transition-all duration-200 ease-in-out z-50"
								>
									{agents?.map((agent) => (
										<button
											key={agent.language}
											onClick={() => selectLanguage(agent.language)}
											disabled={selectedLanguage === agent.language}
											className={`w-full flex items-center space-x-3 px-4 py-3 text-left hover:bg-gray-50 
                                       transition-colors duration-150 text-sm font-medium
                                       ${
																					selectedLanguage === agent.language
																						? "bg-blue-50 text-blue-700"
																						: "text-gray-700"
																				}`}
										>
											<span>{agent.language}</span>
											{selectedLanguage === agent.language && (
												<svg
													className="w-4 h-4 ml-auto text-blue-600"
													fill="currentColor"
													viewBox="0 0 20 20"
												>
													<path
														fillRule="evenodd"
														d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
														clipRule="evenodd"
													/>
												</svg>
											)}
										</button>
									))}
								</div>
							)}

							{/* Overlay to close dropdown when clicking outside */}
							{isLanguageDropdownOpen && (
								<div
									className="fixed inset-0 z-40"
									onClick={() => setIsLanguageDropdownOpen(false)}
								/>
							)}
						</div>
					</div>
				</div>

				{/* Right panel - Messages */}
				{isMessagesOpen && (
					<div
						className="bg-gradient-to-b from-slate-800 to-slate-900 
                          transition-all duration-500 ease-in-out
                          rounded-3xl
                          shadow-2xl
                          portrait:h-1/2 portrait:md:h-full
                          landscape:h-full
                          portrait:md:w-full portrait:md:max-w-sm 
                          landscape:w-full landscape:max-w-sm 
                          lg:max-w-md xl:max-w-lg overflow-hidden"
						style={{ borderRadius: "53px" }}
					>
						<div className="flex-1 h-full">
							<DFXiaomiMessages />
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
